import type { VideoItem } from "@/types/video";

export interface VideoFilters {
  type?: string;
  genre?: string;
  region?: string;
  year?: string;
  keyword?: string;
}

const ALL = "全部";

export function filterVideos(list: VideoItem[], filters: VideoFilters): VideoItem[] {
  const keyword = (filters.keyword || "").trim().toLowerCase();

  return list.filter((item) => {
    if (filters.type && filters.type !== ALL && item.type !== filters.type) return false;
    if (filters.genre && filters.genre !== ALL && !item.tags.includes(filters.genre)) return false;
    if (filters.region && filters.region !== ALL && item.region !== filters.region) return false;
    if (filters.year && filters.year !== ALL && String(item.year) !== filters.year) return false;

    if (keyword) {
      const haystack = [
        item.title,
        item.type,
        item.region,
        String(item.year),
        item.director,
        item.summary,
        ...item.tags,
        ...item.cast,
      ]
        .join(" ")
        .toLowerCase();
      if (!haystack.includes(keyword)) return false;
    }

    return true;
  });
}

export function sortVideos(list: VideoItem[], sort: string): VideoItem[] {
  const sorted = [...list];
  if (sort === "最新") {
    sorted.sort((a, b) => b.year - a.year || b.rating - a.rating);
  } else if (sort === "评分") {
    sorted.sort((a, b) => b.rating - a.rating || b.year - a.year);
  } else {
    sorted.sort((a, b) => b.rating * 10 + b.year - (a.rating * 10 + a.year) || a.title.localeCompare(b.title));
  }
  return sorted;
}

export function paginate<T>(list: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return list.slice(start, start + pageSize);
}

export function totalPages(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}